<template>
    <div class="box-body">
        <view-edit ref="viewEdit"
                   v-model="goalLines"
                   :comparison="historyLines"
                   :layout="layout"
                   :edit-mode-on="editModeOn"
                   :sending="sending"
                   :show-delete="true"
                   @cancel-pressed="cancelPressed"
                   @delete-pressed="deletePressed"
                   @update:model-value="updatePressed" />
    </div>

    <div :id="deleteId"
         class="modal fade lblTextCenter"
         tabindex="-1"
         role="dialog"
         :aria-labelledby="`${deleteId}Title`"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered dialog-less-wide"
             role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <label :id="`${deleteId}Title`"
                           class="modal-title"> <i class="icon icon-book-open-variant" />Delete recovery goal</label>
                </div>
                <div class="modal-body">
                    <div>
                        <label>
                            Delete this Recovery Goal block? {{ recoveryGoalBlockId }}
                        </label>
                        <br>
                    </div>
                </div>
                <div class="modal-footer btnCenterModal">
                    <button type="button"
                            class="btn btn-color btn-outline-primary btn-sm"
                            @click="cancelDeletePressed()">
                        Go Back
                    </button>
                    <button type="button"
                            class="btn btn-primary btn-sm btn-dark-color default-button"
                            @click="deleteRecoveryGoalConfirm()">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, defineExpose, computed, ref, onMounted } from 'vue';
    import { modalDialog } from '../../js/ModalDialog.js';
    import ViewEdit from '../viewEdit/ViewEdit.vue';

    const props = defineProps({
        modelValue: { // recovery goal block
            type: Object,
            default: null
        },
        history: { // historic items
            type: Object,
            default: null
        },
        patientId: {
            type: Number,
            default: 0
        },
        editState: {
            type: Number,
            default: 0
        },
        editModeOn: {
            type: Boolean,
            default: false
        },
        urlHead: {
            type: String,
            default: null
        }
    });

    const emit = defineEmits(['update:modelValue', 'cancelPressed', 'deletePressed', 'updatePressed']);
    defineExpose({setEditData});


    // eslint-disable-next-line
    const goalPlanRecoveryGoalTypes = ecaptisEnums.goalPlanRecoveryGoalTypes;

    const goalItems = computed(() => props.modelValue.recoveryGoalItems);
    const historyLines = computed(() => props.history ? generateGoalLines(props.history) : null);
    const layout = computed(() => calcLayout(goalItems.value));
    const deleteId = computed(() => `DeleteGoalDialog-${props.modelValue.goalPlanRecoveryGoalBlockId}`);

    const goalLines = ref([]);
    const sending = ref(false);

    const viewEdit = ref(null);

    onMounted(() => {
        goalLines.value = generateGoalLines(goalItems.value);
    });


    function generateGoalLines(goalItems) {
        let lines = {};
        for (let i = 0; i < goalItems.length; ++i) {
            let item = goalItems[i];
            let lineDataName = `data_${i}`;
            if (item.goalType == goalPlanRecoveryGoalTypes.Checkbox) {
                lines[lineDataName] = (item.text == "1") ? true : false;
            } else { // string and date
                lines[lineDataName] = item.text;
            }
        }
        return lines;
    }

    function generateGoalItems(goalLines) {
        let items = [];
        for (let i = 0; i < goalItems.value.length; ++i) {
            let item = { ...goalItems.value[i] };
            let lineDataName = `data_${i}`;
            if (item.goalType == goalPlanRecoveryGoalTypes.Checkbox) {
                item.text = goalLines[lineDataName] ? "1" : "0";
            } else { // string or date
                item.text = goalLines[lineDataName];
            }
            items.push(item);
        }
        return items;
    }

    function calcLayout(goalItems) {
        let layout = {
            id: `recoverygoal-items`,
            editTitle: "Recovery Goal",
            editSize: "dialog-adaptive",
        };

        let rows = [];
        for (let i = 0; i < goalItems.length; ++i) {
            let item = goalItems[i];
            let column = {
                title: item.name,
                attributeName: `data_${i}`
            };

            if (item.goalType == goalPlanRecoveryGoalTypes.String) {
                column.editType = "textarea";
            } else if (item.goalType == goalPlanRecoveryGoalTypes.Date) {
                column.editType = "date";
            } else { // checkbox
                column.editType = "checkbox";
                column.falseTrueNames = ["No", "Yes"];
            }
            let row = {
                columns: [column]
            }
            rows.push(row);
        }

        layout.rows = rows;

        return layout;
    }

    function cancelPressed() {
        emit("cancelPressed");
    }

    function updatePressed() {
        let goalItems = generateGoalItems(goalLines.value);
        let updateGoalItems = {
            goalBlockId: props.modelValue.goalPlanRecoveryGoalBlockId,
            goalItems: goalItems,
            patientId: props.patientId
        };

        emit('updatePressed', updateGoalItems);
    }

    function deletePressed() {
        cancelPressed(); // close the other dialog
        modalDialog.openModal(deleteId.value);
    }

    function cancelDeletePressed() {
        modalDialog.closeModal("DeleteRecoveryGoal");
    }

    function deleteRecoveryGoalConfirm() {
        modalDialog.closeModal(deleteId.value);
        emit("deletePressed", props.recoveryGoalBlockId);
    }

    function setEditData(data) {
        //viewEdit.value.setEditData(generateGoalLines(data));
        //console.log('RecoveryGoalItems - setEditData: ', generateGoalLines(data));
        goalLines.value = generateGoalLines(data);
    }



</script>


